import { useState, useEffect, useCallback } from 'react'

const useScrolledDown = breakpoint => {
  const [scrolledDown, setScrolledDown] = useState(false)

  const handleScroll = useCallback(() => {
    const isScrolled = window.scrollY > breakpoint
    setScrolledDown(isScrolled)
  }, [breakpoint])
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    // Cleanup function to remove the event listener when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll]) // Empty dependency array ensures that this effect only runs once when the component mounts

  return scrolledDown
}

export default useScrolledDown
